const LogoFull = () => (
  <img
    src="/fondative-logo.jpg"
    alt="Fondative"
    style={{ height: 40, width: 'auto', objectFit: 'contain' }}
  />
);

export default LogoFull;
